import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetHypothesesParams } from '@/shared/api/end-points/hypothesis'
import { HypothesisResponse } from '../../lib'

const get = async (params: GetHypothesesParams) => {
  return await api.json<HypothesisResponse[]>(API_END_POINTS.hypothesis.getHypotheses(params))
}

export default get
